import { render, staticRenderFns } from "./RequestedTrade.vue?vue&type=template&id=6aaf7dea"
import script from "./RequestedTrade.vue?vue&type=script&lang=ts"
export * from "./RequestedTrade.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports